import { useState } from "react";
import {
  DrawerWrapper,
  DrawerContainer,
  MuiDrawer,
  DrawerTopMenuWrapper,
  DrawerLanguageSwitch,
} from "styles/jss/NavDrawer.styles";
import { Button } from "@mui/material";
import NavLogo from "./NavLogo";
import useScrollSpy from "utils/hooks/useScrollSpy";
import HamburgerMenu from "../../components/IconsSvg/HamburgerMenu";
import { useRouter } from "next/router";
import DrawerMenu from "./DrawerMenu";
import NextImage from "../../components/NextImage";
import { LogoWrapper } from "../../styles/jss/Navigation.styles";
import CloseIcon from "../../components/IconsSvg/CloseIcon";
import DrawerLanguage from "./DrawerLanguage";
import DrawerTopMenu from "./DrawerTopMenu";

export default function NavDrawer({ logos, navigation }) {
  const { locale } = useRouter();
  const [state, setState] = useState(false);

  const toggleDrawer = open => event => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState(open);
  };

  const stickyClass = useScrollSpy(false, 0);

  return (
    <DrawerWrapper className={`${stickyClass ? "stick" : ""}`}>
      <DrawerContainer>
        <Button className="hamburger" onClick={toggleDrawer(true)}>
          <HamburgerMenu />
        </Button>
        <NavLogo logos={logos} sticky={stickyClass} />
        <MuiDrawer
          locale={locale}
          anchor={locale === "fa" ? "right" : "left"}
          open={state}
          onClose={toggleDrawer(false)}
        >
          <DrawerTopMenu logos={logos} toggleDrawer={toggleDrawer} />
          <DrawerMenu navigation={navigation} toggleDrawer={toggleDrawer} />
          <DrawerLanguage />
        </MuiDrawer>
      </DrawerContainer>
    </DrawerWrapper>
  );
}
